var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#5C5F62",
  clipPath: "url(#eye_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.4 7.998a.45.45 0 0 1-.068.24c-1.461 2.324-3.105 3.36-5.33 3.36-2.227 0-3.87-1.037-5.331-3.36a.45.45 0 0 1 0-.48C4.13 5.436 5.776 4.399 8 4.399s3.87 1.037 5.33 3.36a.45.45 0 0 1 .07.24m-6.649 1.87a2.25 2.25 0 1 0 2.5-3.741 2.25 2.25 0 0 0-2.5 3.742m2.6-1.87a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.4 3.8a.6.6 0 0 0 .6-.6V2h1.2a.6.6 0 0 0 0-1.2H1.4a.6.6 0 0 0-.6.6v1.8a.6.6 0 0 0 .6.6M14.599.8h-1.8a.6.6 0 0 0 0 1.2H14v1.2a.6.6 0 0 0 1.2 0V1.4a.6.6 0 0 0-.6-.6M3.2 14H2v-1.2a.6.6 0 0 0-1.2 0v1.799a.6.6 0 0 0 .6.6h1.8a.6.6 0 0 0 0-1.2M14.599 12.2a.6.6 0 0 0-.6.6V14h-1.2a.6.6 0 0 0 0 1.199h1.8a.6.6 0 0 0 .6-.6v-1.8a.6.6 0 0 0-.6-.6"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "eye_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgEye;